import React, { useState } from 'react';
import './../../entrydoor.css';

const MultipointPrep = ({ value, onChange, label = 'Multipoint Prep:', childs = [] }) => { // Set default value for childs
    const [selectedMultipointPrep, setSelectedMultipointPrep] = useState(value || "");

    const visibleShapes = ["No"];

    const handleMultipointPrepChange = (e) => {
        const newValue = e.target.value;
        setSelectedMultipointPrep(newValue);
        onChange(e.target.value);

        // Dynamically fetch and modify styles for dependent controls if any exist
        if (Array.isArray(childs) && childs.length > 0) {
            childs.forEach((childId) => {
                const element = document.getElementById(childId);
                if (element) {
                    element.style.display = visibleShapes.includes(newValue) ? "block" : "none";
                    const label = element.previousElementSibling; // Fetch the label,block if present
                    if (label) {
                        label.style.display = visibleShapes.includes(newValue) ? "block" : "none";
                    }
                }
            });
        }
    };

    return (
        <div className="a-container">
            <label htmlFor="MultipointPrep">{label}</label>
            <select
                id="MultipointPrep"
                value={selectedMultipointPrep}
                onChange={handleMultipointPrepChange}
            >
              <option value="Yes">{selectedMultipointPrep === "Yes" ? "Yes ✔" : "Yes"}</option>
              <option value="No">{selectedMultipointPrep === "No" ? "No ✔" : "No"}</option>
            </select>
        </div>
    );
};

export default MultipointPrep;
